import { nbsp } from "./unicodes.js";

export function nbspify(input: string | undefined): string {
	return (input ?? "")
		.normalize("NFC")
		.replace(/(?<=(?:^|[^\p{General_Category=Letter}])\p{General_Category=Letter}) +|\s(?=\d|%)/gu, nbsp);
}
